import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {MatTableDataSource} from "@angular/material/table";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable, Subject, take} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {LogService} from "../../../../services/log.service";
import {Centre} from "../../../../interfaces/Centres";
import {CentreService} from "../../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import {catchError, finalize, map, takeUntil} from "rxjs/operators";
import {LoadingService} from "../../../../services/loading.service";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import * as XLSX from "xlsx";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {EmployeeService} from "../../../../services/employee.service";

@Component({
  selector: 'app-report-card-table',
  templateUrl: './report-card-table.component.html',
  styleUrls: ['./report-card-table.component.scss']
})
export class ReportCardTableComponent implements OnInit,OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  displayedColumns: string[] = ['position', 'studentName','teacher','center', 'date', 'symbol'];
  dataSource:MatTableDataSource<any>
  mRef:Observable<unknown[]>
  private isDestroyed: Subject<void> = new Subject<void>();
  endDate: Date | any;
  startDate: Date | any;

  selectedCentre: string = '';
  selectStudent: string = '';
  selectedTeacher: string = '';
  uniqueTeachers: string[] = [];
  uniqueStudents: string[] = [];
  centres$: Observable<Centre[]>
  userdata = JSON.parse(localStorage.getItem('userData')!)
  isExternal =  this.userdata.department == 'External User'
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @ViewChild(MatSort) sort?: MatSort;
  constructor(private readonly mFirestore:AngularFirestore,
              private matSnackbar:MatSnackBar,
              private loadingService: LoadingService,
              private mLogService:LogService,
              private readonly centreService: CentreService,
              private readonly financialYearService: FinancialYearService,
              private readonly mEmployeeService:EmployeeService,
              private router: Router  ,// Inject Router for navigation
  private route:ActivatedRoute) {
    this.centres$ = this.centreService.getAllCentres()
  this.mRef = this.mFirestore.collection(this.env.reportCard,ref => ref.orderBy('date','desc')).valueChanges({idField:'id'})
  this.dataSource =new MatTableDataSource<any>()
    this.loadUniqueValues();
  }
  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.loadData();
  }

  loadData() {
    this.loadingService.setLoading(true); // Start loader
    this.mRef.pipe(
      take(1),
      catchError(error => {
        console.error('Error loading data:', error);
        this.matSnackbar.open('Failed to load data. Please try again.', '', {
          duration: 3000,
          panelClass: 'snackbar-error',
        });
        return []; // Return an empty array to continue the stream
      }),
      finalize(() => {
        this.loadingService.setLoading(false); // Stop loader
      })
    ).subscribe(res => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.paginator = this.paginator;;
    });
  }

  loadUniqueValues() {

    this.mEmployeeService.getAllTeachers().pipe(
      map(data => {
        this.uniqueTeachers = Array.from(
          new Set(data.map(item => item?.userName).filter(name => name))
        ).sort();
      }),
      takeUntil(this.isDestroyed)
    ).subscribe();

    this.mFirestore.collection<any>(this.env.reportCard).valueChanges().pipe(
      map(data => {

        this.uniqueStudents = Array.from(
          new Set(data.map(item => item.studentName))
        ).sort();
      }),
      takeUntil(this.isDestroyed)
    ).subscribe();
  }
  selectedCentreCode: any;
  logActivityAndNavigate(action: string, reportId: string) {
    let description = action === 'View'
      ? 'Education view Report Card by user'
      : 'Education edit Report Card by user';

    // Log the activity
    const activity = {
      date: new Date().getTime(),
      section: 'Group Education',
      action: action,
      description: description,
      currentIp: localStorage.getItem('currentip')!
    };

    this.mLogService.addLog(activity).then(() => {
      console.log(`${action} log added successfully`);

      // Navigate to the appropriate route after logging
      if (action === 'View') {
        this.router.navigate(['/home/reports/report-card-view', reportId, { viewMode: true }]);
      } else if (action === 'Edit') {
        this.router.navigate(['/home/reports/report-card', reportId, { viewMode: false }]);
      }
    }).catch(error => {
      console.error('Error adding audit log:', error);
    });
  }

@needConfirmation()
    delete(id:string) {
      this.mFirestore.collection(this.env.reportCard).doc(id).delete().then(()=>{
        this.matSnackbar.open('Deleted Successfully','',{
          panelClass:'snackbar-warn',
          duration:3000
        })
        let activity = {
          date: new Date().getTime(),
          section: 'Group Education',
          action: 'Delete',
          description: `Education Delete Education Impact Report by user`,
          currentIp: localStorage.getItem('currentip')!
        }
        this.mLogService.addLog(activity)
      })
    }
  applyFilter($event: any) {
    this.dataSource.filter = ($event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filterPredicate = (data, filter) => {
      const teacherName = `${data.teacher?.name || ''}`.toLowerCase();
      const studentName = `${data.studentName || ''}`.toLowerCase();
      const centreName = `${data.centreName || ''}`.toLowerCase();
      const date = data.date.toDate ? data.date.toDate().toLocaleDateString().toLowerCase() : new Date(data.date);
      return teacherName.includes(filter) ||
        studentName.includes(filter) ||
        centreName.includes(filter) ||
        date.includes(filter);
    };
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  downloadExcel() {
    if (!this.dataSource || !this.dataSource.data || this.dataSource.data.length === 0) {
      this.matSnackbar.open('No data available to download', '', {
        duration: 2000
      });
      return;
    }

    const exportData = this.dataSource.data.map((item: any, index: number) => ({
      'Sr No': index + 1,
      'Centre Name': item.centreName || '',
      'Teacher Name': item.teacher?.name || '',
      'Student Name': item.studentName || '',
      'Date': item.date?.toDate
        ? item.date.toDate().toLocaleDateString()
        : '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report Cards');

    XLSX.writeFile(workbook, 'Report_Card_List.xlsx');

    //  Activity log (matches your existing pattern)
    const activity = {
      date: new Date().getTime(),
      section: 'Group Education',
      action: 'Download',
      description: 'Report Card list downloaded as Excel',
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    this.matSnackbar.open('Excel downloaded successfully', '', {
      duration: 2000
    });
  }

  searchData() {
    this.loadingService.setLoading(true); // Start loader
    const startDate = this.startDate ? new Date(this.startDate) : new Date(0);
    const endDate = this.endDate ? new Date(this.endDate) : new Date();
    const selectedTeacher = this.selectedTeacher || '';
    const selectedCentreCode = this.selectedCentreCode || '';
    const selectedStudent = this.selectStudent || '';

    this.mRef.pipe(
      map((data: any[]) => {
        return data.filter(item => {
          const itemDate = item.date.toDate ? item.date.toDate() : new Date(item.date);
          const matchesDateRange = itemDate >= startDate && itemDate <= endDate;
          const matchesTeacher = selectedTeacher ? item.teacher.name === selectedTeacher : true;
          const matchesStudent = selectedStudent ? item.studentName === selectedStudent : true;
          const matchesCentre = selectedCentreCode ? item.centreCode === selectedCentreCode : true;
          return matchesDateRange && matchesTeacher && matchesCentre && matchesStudent;
        });
      }),
      take(1), // Ensure only one emission
      catchError(error => {
        console.error('Error fetching data:', error);
        this.matSnackbar.open('Error fetching data. Please try again.', '', {
          duration: 3000,
          panelClass: 'snackbar-error',
        });
        return []; // Return an empty array to continue the stream
      }),
      finalize(() => this.loadingService.setLoading(false)) // Stop loader
    ).subscribe(filtered => {
      this.dataSource = new MatTableDataSource(filtered);
      this.dataSource.paginator = this.paginator;
    });
  }
  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.selectedTeacher = '';
    this.selectStudent = '';
    this.selectedCentreCode = '';
    // Reload unfiltered data
    this.mRef.pipe(
      map(data => {
        return data;
      }),
      takeUntil(this.isDestroyed)
    ).subscribe(allData => {
      this.dataSource = new MatTableDataSource(allData);
      this.dataSource.paginator = this.paginator;
    });
  }

  setSelectedCentreCode($event: MatSelectChange) {
    this.selectedCentreCode = $event.value
    console.log(this.selectedCentreCode)
  }

  protected readonly PermissionType = PermissionType;

  ngOnDestroy(): void {
    this.isDestroyed.next();
    this.isDestroyed.complete();
  }

}
